import {
  ADD_PAYMENT_METHOD_REQUEST,
  ADD_PAYMENT_METHOD_SUCCESS,
  ADD_PAYMENT_METHOD_ERROR,
  FINISH_VERIFICATION_ERROR,
  FINISH_VERIFICATION_REQUEST,
  FINISH_VERIFICATION_SUCCESS,
  HIDE_CARD_VERIFICATION,
  PAYMENTS_HIDE_SPINNER,
  PAYMENTS_SHOW_SPINNER,
  RESET_PAYMENTS,
  SHOW_CARD_VERIFICATION,
} from '../actions/payments';
import { addPaymentMethodRequest, addPaymentMethodSuccess, addPaymentMethodError } from './addPaymentMethodActions';
import {
  finishVerificationError,
  finishVerificationRequest,
  finishVerificationSuccess,
  hideCardVerification,
  showCardVerification,
} from './addCardVerificationActions';
import { paymentHideSpinner, paymentShowSpinner } from './addPaymentMethodSpinnerActions';

export const initialState = {
  isSpinnerVisible: false,
  verifyPaymentBin: null,
  verifyPaymentNonce: null,
  verifyPaymentAmount: null,
  verifyPaymentBillingInfo: null,
};

const ACTIONS = {
  [ADD_PAYMENT_METHOD_REQUEST]: addPaymentMethodRequest,
  [ADD_PAYMENT_METHOD_SUCCESS]: addPaymentMethodSuccess,
  [ADD_PAYMENT_METHOD_ERROR]: addPaymentMethodError,
  [SHOW_CARD_VERIFICATION]: showCardVerification,
  [HIDE_CARD_VERIFICATION]: hideCardVerification,
  [FINISH_VERIFICATION_REQUEST]: finishVerificationRequest,
  [FINISH_VERIFICATION_SUCCESS]: finishVerificationSuccess,
  [FINISH_VERIFICATION_ERROR]: finishVerificationError,
  [PAYMENTS_SHOW_SPINNER]: paymentShowSpinner,
  [PAYMENTS_HIDE_SPINNER]: paymentHideSpinner,
  [RESET_PAYMENTS]: () => (initialState),
};

export default function addPaymentMethodReducer(state = initialState, action) {
  return ACTIONS[action.type] ? ACTIONS[action.type]({ state, action }) : state;
}
